// Constants.
import * as PayUserConstants from 'constants/PayUserConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isUpdating: false,
  isUpdated: true,
  errorMessage: '',
};

export default function products(state = initialState, action = {}) {
  switch (action.type) {
    case PayUserConstants.UPDATE_PAY_USER_CARD_REQUEST:
      return {
        ...state,
        isUpdating: true,
        isUpdated: false,
      };
    case PayUserConstants.UPDATE_PAY_USER_CARD_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        isUpdated: true,
      };
    case PayUserConstants.UPDATE_PAY_USER_CARD_FAILURE:
      return {
        ...state,
        isUpdating: false,
        isUpdated: true,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isUpdating: false,
        isUpdated: true,
        errorMessage: '',
      };
    default:
      return state;
  }
}
